// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

export const patientPoints = (state) =>
  get(state, ['reports', 'patientPoints'], {})

export const patientPointsReport$ = createSelector(
  patientPoints,
  ({ patientPointsReport = [] }) => patientPointsReport
)

export const patientPointsReportLoading$ = createSelector(
  patientPoints,
  ({ patientPointsReportLoading = false }) => patientPointsReportLoading
)
